import { queryOptions, useQuery } from '@tanstack/react-query';

import { webhooksApi } from '../api/webhooks-api';

import { webhookKeys } from './webhook-keys';

/** At most 20 endpoints per store, so the list is not paginated. */
export function webhookEndpointsQueryOptions(storeId: string) {
  return queryOptions({
    queryKey: webhookKeys.list(storeId),
    queryFn: () => webhooksApi.list(storeId),
  });
}

export function useWebhookEndpoints(storeId: string) {
  return useQuery(webhookEndpointsQueryOptions(storeId));
}
